







































































































import Vue, { PropType } from 'vue';
import { serializeDate } from '@/utils/date';
import { DATE_SEPARATOR_IN_FORM } from '@/utils/constants';
import FileUploadMixin from '@/components/mixins/FileUploadMixin.vue';

export interface FormDataInterface {
  title?: string;
  organization?: string;
  website_url?: string;
  description?: string;
  start_date?: string;
  end_date?: string;
}

export default Vue.extend({
  mixins: [FileUploadMixin],
  props: {
    sectionItem: {
      // FIXME update generated format
      // type: Object as () => CvSectionDateItem,
      type: Object as PropType<any>,
      required: true,
    },
    isDeletable: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    const {
      title,
      organization,
      website_url,
      description,
      start_date_year,
      start_date_month,
      start_date_day,
      end_date_year,
      end_date_month,
      end_date_day,
    } = this.sectionItem;
    return {
      formData: {
        title,
        organization,
        website_url,
        description: description || '',
        start_date: serializeDate(
          {
            year: start_date_year,
            month: start_date_month,
            day: start_date_day,
          },
          DATE_SEPARATOR_IN_FORM
        ),
        end_date: serializeDate(
          {
            year: end_date_year,
            month: end_date_month,
            day: end_date_day,
          },
          DATE_SEPARATOR_IN_FORM
        ),
      } as FormDataInterface,
    };
  },
  methods: {
    onSubmit() {
      this.$emit('submit', this.formData);
    },
    onCancel() {
      this.$emit('cancel');
    },
    onDelete() {
      this.$emit('delete');
    },
  },
});
